// extracted by mini-css-extract-plugin
export default {"container":"TextPrompt_container__FdPzG","pulse":"TextPrompt_pulse__0krf4"};